export class NumberUtils {

    public static truncateValue(value: number): number {
        return Math.trunc(value * 100) / 100;
    }

    public static roundValue(number: number, precision: number): number {
        const factor = Math.pow(10, precision);
        const tempNumber = number * factor;
        const roundedTempNumber = Math.round(tempNumber);
        return roundedTempNumber / factor;
    }

    public static formatCurrency(amount: number): string {
        return "$" + amount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    }
}
